<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div v-if="!loading">
                    <data-table :headings="depotHeadings" :data="depots" :hasActions="true" 
                                :pagingDetails="pagingDetails"
                                :stateChanged="filterStateChanged"
                                @actionClicked="onDepotActionClicked" @filterSearchClicked="onFilterSearchClicked">
                        <template #actionButton>
                            <div class="w-100">
                                <button class="btn btn-primary" @click="onAddDepotClick">Add Depot</button>
                            </div>
                        </template>
                        <template #filter>
                            <div class="p-3">
                                <div class="input-group pb-4">
                                    <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="filter.customerSearchQuery">
                                    <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon1">
                                        <i class="fas fa-search"></i>
                                    </span>
                                    </div>
                                </div>
                                <div class="pb-4">
                                    <label>Provinces</label>
                                    <bootstrap-select  :selectOptions="provincesFilter" :selectedOption="filter.provinceId" :elementId="'provinceFilterSelect'"
                                                       :returnSelectedOptionText="true"
                                                       @changeSelect="onProvinceFilterSelected"></bootstrap-select>
                                </div>
                                <active-inactive-radio-buttons :activeInactiveKey="filter.activeOrInactiveItems"
                                                               :componentId="'depotFilterRadioButtons'"
                                                               @activeInactiveSelected="onActiveInactiveFilterSelected"></active-inactive-radio-buttons>
                            </div>
                        </template>
                    </data-table>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
        </div>
    </div>

    <mark-as-active-inactive-modal
                :heading="depotMarkAsActiveInactiveModal.heading"
                :modalId="depotMarkAsActiveInactiveModal.modalId"
                :isSaving="depotMarkAsActiveInactiveModal.isSaving"
                :showModal="depotMarkAsActiveInactiveModal.showModal"
                :isActive="depotMarkAsActiveInactiveModal.isActive"
                @closeClicked="depotMarkAsActiveInactiveModal.showModal = false"
                @saveButtonClicked="onMarkAsActiveInactiveSaveClick"></mark-as-active-inactive-modal>
    
    <modal-form
            :heading="depotAddEditFormModal.heading"
            :modalId="depotAddEditFormModal.modalId"
            :isSaving="depotAddEditFormModal.isSaving"
            :showModal="depotAddEditFormModal.showModal"
            @closeClicked="onAddOrEditDepotModalCloseClick"
            @saveButtonClicked="onAddOrEditDepotSaveClick">
        <template #form>
            <form>
                <div class="form-group">
                    <label for="nameInput">
                        Name
                    </label>
                    <div class="text-danger" v-if="depotAddEditFormModal.depot.name.hasError">
                        {{depotAddEditFormModal.depot.name.errorMessage}}
                    </div>
                    <input type="text" class="form-control" id="nameInput" v-model="depotAddEditFormModal.depot.name.value"/>
                </div>
                <div class="form-group">
                    <label for="streetInput">
                        Street
                    </label>
                    <div class="text-danger" v-if="depotAddEditFormModal.depot.street.hasError">
                        {{depotAddEditFormModal.depot.street.errorMessage}}
                    </div>
                    <input type="text" class="form-control" id="streetInput" v-model="depotAddEditFormModal.depot.street.value"/>
                </div>
                <div class="form-group">
                    <label for="suburbInput">
                        Suburb
                    </label>
                    <div class="text-danger" v-if="depotAddEditFormModal.depot.suburb.hasError">
                        {{depotAddEditFormModal.depot.suburb.errorMessage}}
                    </div>
                    <input type="text" class="form-control" id="suburbInput" v-model="depotAddEditFormModal.depot.suburb.value"/>
                </div>
                <div class="form-group">
                    <label for="cityInput">
                        City
                    </label>
                    <div class="text-danger" v-if="depotAddEditFormModal.depot.city.hasError">
                        {{depotAddEditFormModal.depot.city.errorMessage}}
                    </div>
                    <input type="text" class="form-control" id="cityInput" v-model="depotAddEditFormModal.depot.city.value"/>
                </div>
                <div class="form-group">
                    <label for="provinceSelect">
                        Province
                    </label>
                    <div class="text-danger" v-if="depotAddEditFormModal.depot.provinceId.hasError">
                        {{depotAddEditFormModal.depot.provinceId.errorMessage}}
                    </div>
                    <bootstrap-select  :selectOptions="provinces" :selectedOption="depotAddEditFormModal.depot.provinceId.value" :elementId="'provinceSelect'"
                                       :returnSelectedOptionText="true"
                                       @changeSelect="onProvinceSelected"></bootstrap-select>
                </div>
                <div class="form-group">
                    <label for="postalCodeInput">
                        Postal Code
                    </label>
                    <div class="text-danger" v-if="depotAddEditFormModal.depot.postalCode.hasError">
                        {{depotAddEditFormModal.depot.postalCode.errorMessage}}
                    </div>
                    <input type="text" class="form-control" id="postalCodeInput" v-model="depotAddEditFormModal.depot.postalCode.value"/>
                </div>
                <div class="form-group">
                    <label for="phoneNumberInput">
                        Phone Number
                    </label>
                    <div class="text-danger" v-if="depotAddEditFormModal.depot.primaryPhoneNumber.hasError">
                        {{depotAddEditFormModal.depot.primaryPhoneNumber.errorMessage}}
                    </div>
                    <input type="text" class="form-control" id="phoneNumberInput" v-maska data-maska="### ### ####" v-model="depotAddEditFormModal.depot.primaryPhoneNumber.value"/>
                </div>
                <div class="form-group">
                    <label for="emailAddressInput">
                        Email Address
                    </label>
                    <div class="text-danger" v-if="depotAddEditFormModal.depot.primaryEmailAddress.hasError">
                        {{depotAddEditFormModal.depot.primaryEmailAddress.errorMessage}}
                    </div>
                    <input type="email" class="form-control" id="emailAddressInput" v-model="depotAddEditFormModal.depot.primaryEmailAddress.value"/>
                </div>
                <div class="form-group">
                    <label for="gpsCoordinatesInput">
                        GPS Coordinates
                    </label>
                    <div class="text-danger" v-if="depotAddEditFormModal.depot.gpsCoordinates.hasError">
                        {{depotAddEditFormModal.depot.gpsCoordinates.errorMessage}}
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <label>Latitude</label>
                            <div class="text-danger" v-if="depotAddEditFormModal.depot.latitude.hasError">
                                {{depotAddEditFormModal.depot.latitude.errorMessage}}
                            </div>
                            <input type="text" class="form-control" id="latitudeInput" v-model="depotAddEditFormModal.depot.latitude.value"/>
                        </div>
                        <div class="col-6">
                            <label>Longitude</label>
                            <div class="text-danger" v-if="depotAddEditFormModal.depot.longitude.hasError">
                                {{depotAddEditFormModal.depot.longitude.errorMessage}}
                            </div>
                            <input type="text" class="form-control" id="longitudeInput" v-model="depotAddEditFormModal.depot.longitude.value"/>
                        </div>
                    </div>
                </div>
            </form>
        </template>
    </modal-form>
    
    <manage-depot-products-modal
        :heading="depotManageProductsModal.heading"
        :showModal="depotManageProductsModal.showModal"
        :modalId="depotManageProductsModal.modalId"
        :depotId="depotManageProductsModal.depotId"
        @okClicked="onManageDepotProductsModalOkClicked"></manage-depot-products-modal>
</div>
